import { logStatus } from "../utils";
const convertDialogParams = (type, options) => {
    const defaultMessage = type === "SingleInputDialog" ? "Enter value:" : "Are you sure?";
    const message = options.question ?? options.inputLabel ?? defaultMessage;
    return {
        type: type === "YesNoDialog" ? "YesNoCancel" : type,
        mode: "WindowContainer",
        title: options.title ?? "Yes/No Question",
        message,
        messageTitle: "",
        showAffirmativeButton: options.showAffirmativeButton ?? true,
        affirmativeButtonName: options.affirmativeResponseLabel ?? "Yes",
        showNegativeButton: options.showNegativeButton ?? true,
        negativeButtonName: options.negativeResponseLabel ?? "No",
        showCancelButton: options.showCancelButton ?? true,
        cancelButtonName: options.cancelResponseLabel ?? "Cancel",
        ...options,
        timerDuration: options.timerDuration ? options.timerDuration / 1000 : undefined
    };
};
export class DialogManagerClientGlueImpl {
    constructor(gluePromise, asyncConstructors, loggerClient) {
        this.gluePromise = gluePromise;
        this.asyncConstructors = asyncConstructors;
        this.loggerClient = loggerClient;
        const pw = asyncConstructors.addConstructor();
        gluePromise.then((g) => {
            this.glue = g;
            asyncConstructors.finishConstructor(pw);
        });
    }
    logStatus(method, type, data) {
        logStatus(this.loggerClient, this.glue, {
            api: "DialogManagerClient",
            method, type, data
        });
    }
    async open(type, options, onUserInput) {
        this.logStatus("open", "start", { type, options, onUserInput });
        await this.asyncConstructors.ready();
        const win = this.glue.windows.my();
        if (!win) {
            const error = "Cannot open dialog from within an incompatible window type (e.g. webgroup). You must use the Finsemble dialog implementation";
            console.error(error);
            return error;
        }
        const promise = win.showDialog(convertDialogParams(type, options));
        promise.then((params) => {
            const { action, button, value } = params;
            if (action === "closed") {
                onUserInput(null, { choice: "cancel" });
            }
            else {
                if (button === "affirmative") {
                    onUserInput(null, { choice: "affirmative", value });
                }
                else {
                    onUserInput(null, { choice: "negative" });
                }
            }
        });
        this.logStatus("open", "return", null);
        return null;
    }
}
